export default {
    topics: [
        {
            title: ' doneTransition ',
            href: 'm-WorkflowTask-doneTransition.html',
            attributes: { 'data-id': 'm-WorkflowTask-doneTransition' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-doneTransition-d66e6806',
            topics: [],
        },
        {
            title: ' errorTransition ',
            href: 'm-WorkflowTask-errorTransition.html',
            attributes: { 'data-id': 'm-WorkflowTask-errorTransition' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-errorTransition-d66e6814',
            topics: [],
        },
        {
            title: ' postEvent ',
            href: 'm-WorkflowTask-postEvent.html',
            attributes: { 'data-id': 'm-WorkflowTask-postEvent' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-postEvent-d66e6822',
            topics: [],
        },
        {
            title: ' setCompleted ',
            href: 'm-WorkflowTask-setCompleted.html',
            attributes: { 'data-id': 'm-WorkflowTask-setCompleted' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-setCompleted-d66e6830',
            topics: [],
        },
        {
            title: ' setNextProcessingDate ',
            href: 'm-WorkflowTask-setNextProcessingDate.html',
            attributes: { 'data-id': 'm-WorkflowTask-setNextProcessingDate' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-setNextProcessingDate-d66e6838',
            topics: [],
        },
        {
            title: ' transitionByName ',
            href: 'm-WorkflowTask-transitionByName.html',
            attributes: { 'data-id': 'm-WorkflowTask-transitionByName' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-transitionByName-d66e6846',
            topics: [],
        },
        {
            title: ' transitionByType ',
            href: 'm-WorkflowTask-transitionByType.html',
            attributes: { 'data-id': 'm-WorkflowTask-transitionByType' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-transitionByType-d66e6854',
            topics: [],
        },
        {
            title: ' transitions ',
            href: 'm-WorkflowTask-transitions.html',
            attributes: { 'data-id': 'm-WorkflowTask-transitions' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-transitions-d66e6862',
            topics: [],
        },
        {
            title: ' wait ',
            href: 'm-WorkflowTask-wait.html',
            attributes: { 'data-id': 'm-WorkflowTask-wait' },
            menu: { hasChildren: false },
            tocID: 'm-WorkflowTask-wait-d66e6870',
            topics: [],
        },
    ],
};

